import { render } from "./TableDetailsRight.pug?vue&type=template&id=d2a39bd8&lang=pug"
import script from "./TableDetailsRight.js?vue&type=script&lang=js"
export * from "./TableDetailsRight.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__